/**
 * Páginas abertas pela busca (paleta Ctrl K e folha Mais), guardadas neste navegador por usuário.
 * Só a rota: o rótulo e o grupo vêm do catálogo atual, então página que sumiu ou que o papel
 * não vê mais não aparece nos recentes.
 */
import type { GoToPageItem } from '@/widgets/navigation/goToPageItems'

export const GO_TO_RECENT_LIMIT = 5
const KEY_PREFIX = 'synap:goto-recent:v1:'

const storageKey = (userId: string) => `${KEY_PREFIX}${userId}`

export const pushRecentPath = (paths: readonly string[], path: string): string[] =>
  [path, ...paths.filter((existing) => existing !== path)].slice(0, GO_TO_RECENT_LIMIT)

export const resolveRecentItems = (
  paths: readonly string[],
  items: readonly GoToPageItem[],
): GoToPageItem[] => {
  const byPath = new Map(items.map((item) => [item.to, item]))
  return paths.flatMap((path) => {
    const item = byPath.get(path)
    return item ? [item] : []
  })
}

export const readRecentPaths = (userId: string | null | undefined): string[] => {
  if (!userId) return []
  try {
    const raw = window.localStorage.getItem(storageKey(userId))
    const parsed: unknown = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) return []
    return parsed.filter((p): p is string => typeof p === 'string').slice(0, GO_TO_RECENT_LIMIT)
  } catch {
    return []
  }
}

export const writeRecentPaths = (userId: string | null | undefined, paths: readonly string[]): void => {
  if (!userId) return
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(paths.slice(0, GO_TO_RECENT_LIMIT)))
  } catch {
    // Melhor esforço: sem armazenamento, a busca segue sem recentes.
  }
}

/** Grava a página aberta no topo dos recentes. */
export const rememberRecentPath = (userId: string | null | undefined, path: string): void => {
  writeRecentPaths(userId, pushRecentPath(readRecentPaths(userId), path))
}
